import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Popover, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import eOpsLogo from "../../../images/eops.png";
import excel from "../../../images/excel.png";
import mepcoLogo from "../../../images/mepcoLogo.png";
import pdf from "../../../images/pdf.png";
import print from "../../../images/print.png";
import { cfpBaseUrl } from "../../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
  getShortMonthName,
  companyShortName,
  getCompanyName,
  companyName,
  getLogo,
} from "../../../services/Functions";
import { internalIconStyles } from "../../../style/common";
import "../../../style/common.scss";
import { Code } from "lucide-react";

const EopsUsersStatus = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const {
    token,
    code,
    name,
    roleName,
    roleTypeName,
    cscID,
    cfcLevelId,
    roleId,
    hierarchy: userHierarchy,
  } = useSelector((state) => state.auth);
  const offCode =
    userHierarchy == 1
      ? code
      : userHierarchy == 2
      ? code.slice(0, 2)
      : userHierarchy == 3
      ? code.slice(0, 3)
      : userHierarchy == 4
      ? code.slice(0, 4)
      : userHierarchy == 5
      ? code.slice(0, 5)
      : code;
  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [totals, setTotals] = useState({});
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [desginationCodeToApi, setDesginationCodeToApi] = useState("1135");
  const [desginationName, setDesginationName] = useState("");
  const [desginationList, setDesginationList] = useState([]);
  const [companyCode, setCompanyCode] = useState("15");
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4 || cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const getStats = async (officeCode, roleId) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        officecode: selectedSubDivision
          ? selectedSubDivision
          : selectedDivision
          ? selectedDivision
          : officeCode
          ? officeCode
          : code.slice(0, 2),
        roleId: roleId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "reports/geteOpsSubDivisionUserStatus",
        requestOptions
      );
      const result = await response.json();

      if (result.status == "200") {
        const data = result.data;

        setTableData(data);
      } else if (result.status == "400") {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
      setTableData([]);
    }
    setViewBackdrop(false);
  };

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${formatDate(
      getCurrentDate()
    )}- ${officeName} - (${desginationName}) - eops-user-status-report.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const connectionTypes = [
    "Office Code",
    "Office Name",
    "Web LoggedIn User",
    "Mobile LoggedIn User",
    "Total LoggedOut User",
    "Total User",
  ];

  const connectionTypesExcel = [
    "Circle Code",
    "Circle Name",
    "Division Name",
    "Sub-Division Name",
    "Role Name",
    "LoggedIn User",
    "LoggedOut User",
    "Total User",
  ];

  const [categoryName, setcategoryName] = useState("New Connections");

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);
      const title = `eOps Users Status Report for ${offName} of ${
        getDateDifference(dateFrom, dateTo) > 0
          ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
          : formatDate(dateFrom)
      }`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode
      )
        ? 25
        : 30;
      const logoHeight = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode
      )
        ? 20
        : 10;
      pdf.addImage(
        getLogo(code.slice(0, 2)),
        "PNG",
        15,
        5,
        logoWidth,
        logoHeight
      );

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition = [
        "12",
        "13",
        "11",
        "16",
        "27",
        "48",
        "59",
      ].includes(companyCode)
        ? 43
        : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        ["12", "13", "11", "16", "27", "48", "59"].includes(companyCode)
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(12);
      pdf.text(companyName(code.slice(0, 2)), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `eOps Users Status (${desginationName})for ${companyShortName(code.slice(0, 2))}`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        { content: "Circle Code", styles: { halign: "left" } },
        { content: "Circle Name", styles: { halign: "left" } },
        { content: "Web LoggedIn User", styles: { halign: "left" } },
        { content: "Mobile LoggedIn User", styles: { halign: "left" } },
        { content: "Total LoggedOut User", styles: { halign: "left" } },
        { content: "Total User", styles: { halign: "left" } },
      ];

      let bodyData = [];

      if (tableData && tableData.length > 0) {
        // 🔹 Normal table rows
        bodyData = tableData.map((item) => [
          { content: item.officeCode || "-", styles: { halign: "left" } },
          { content: item.officeName || "-", styles: { halign: "left" } },
          { content: item.totalLoggedInWeb || 0, styles: { halign: "left" } },
          {
            content: item.totalLoggedInMobile || 0,
            styles: { halign: "left" },
          },
          { content: item.totalLoggedOut || 0, styles: { halign: "left" } },
          { content: item.totalUsers || 0, styles: { halign: "left" } },
        ]);

        // 🔹 Add Total row with yellow background (#fff5c0)
        bodyData.push([
          {
            content: "Total",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [255, 245, 192],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [255, 245, 192],
            },
          },
          {
            content: tableData.reduce(
              (sum, item) => sum + (item.totalLoggedInWeb || 0),
              0
            ),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [255, 245, 192],
            },
          },
          {
            content: tableData.reduce(
              (sum, item) => sum + (item.totalLoggedInMobile || 0),
              0
            ),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [255, 245, 192],
            },
          },
          {
            content: tableData.reduce(
              (sum, item) => sum + (item.totalLoggedOut || 0),
              0
            ),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [255, 245, 192],
            },
          },
          {
            content: tableData.reduce(
              (sum, item) => sum + (item.totalUsers || 0),
              0
            ),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [255, 245, 192],
            },
          },
        ]);
      } else {
        // 🔹 No Data Found row
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 6,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: {
          cellPadding: 3,
          fontSize: 8,
          halign: "left",
        },
        theme: "striped",
        tableWidth: pageWidth - 30,
        margin: { left: 15, right: 15 },
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 55 },
          2: { cellWidth: 40 },
          3: { cellWidth: 50 },
          4: { cellWidth: 50 },
          5: { cellWidth: 31 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      const filename = `${companyShortName(code.slice(0, 2))} - ${
        getDateDifference(dateFrom, dateTo) > 0
          ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
          : formatDate(dateFrom)
      } - (${desginationName}) - eops-user-status-report.pdf`;

      if (print) {
        pdf.save(filename);
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  useEffect(() => {
    const getDesgination = async () => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const raw = "";
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          setViewBackdrop(false);
          if (result.message == "Data Found.") {
            setDesginationList(result.data);
          }
        })
        .catch((error) => console.error(error));
    };
    getDesgination();
  }, [companyCode]);

  const getDateDifference = (startDate, endDate) => {
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];
    const start = new Date(startDates);
    const end = new Date(endDates);
    const differenceInTime = end - start;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
  };

  const handleRemarksClick = (event, remarks) => {
    if (remarks && remarks.trim() !== "") {
      setAnchorEl(event.currentTarget);
      setSelectedRemarks(remarks);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const handleChangeDesgination = (e) => {
    const selectedId = e.target.value;
    const selectedName = e.target.options[e.target.selectedIndex].text;

    setDesginationCodeToApi(selectedId);
    setDesginationName(selectedName);
  };

  const currentFilters = {
    officeCode,
    desginationCodeToApi,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [officeCode, desginationCodeToApi]);

  const handleGoClick = () => {
    getStats(officeCode, desginationCodeToApi);

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  useEffect(() => {
  if (desginationList?.length && desginationCodeToApi) {
    const selected = desginationList.find(
      item => String(item.employeeDesignationId) === String(desginationCodeToApi)
    );

    if (selected) {
      setDesginationName(selected.employeeDesignationName);
    }
  }
}, [desginationList, desginationCodeToApi]);

  return (
    <>
      <Box className="form-box">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Box className="application-table" style={{ marginRight: "10px" }}>
            <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
              eOps Users Status Report
            </h3>
            <div className="div-datagrid">
              <div className="reports-container">
                <div
                  className="filter-fields"
                  style={{
                    width: "75%",
                    justifyContent: "flex-start",
                    gap: "15px",
                  }}
                >
                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedCompanyCode}
                        onChange={handleChangeCompany}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={circleCode || ""}
                        onChange={handleCircleChange}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedDivision || ""}
                        onChange={handleDivisionChange}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedSubDivision || ""}
                        onChange={handleSubDivisionChange}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="field-container">
                    <Typography className="field-label">Designation</Typography>
                    <select
                      className="dropdown-field"
                      style={{ backgroundColor: "white" }}
                      value={desginationCodeToApi}
                      onChange={handleChangeDesgination}
                    >
                      {desginationList.map((item, index) => (
                        <option key={index} value={item.employeeDesignationId}>
                          {item.employeeDesignationName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {Number(hierarchy) !== 5 && Number(cfcLevelId) !== 5 && (
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginTop: "10px" }}
                      onClick={handleGoClick}
                      disabled={isGoDisabled || viewBackdrop}
                    >
                      Go
                    </Button>
                  )}
                </div>
                <div className="export-button-container">
                   <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="table-container" style={{ marginBottom: "40px" }}>
                <div id="pdf-table">
                  <div
                    style={{
                      maxHeight: "900px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <table
                      className="table"
                      ref={tableRef}
                      style={{
                        marginBottom: "40px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        <tr
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 3,
                          }}
                        >
                          <th
                            colSpan="14"
                            style={{
                              fontSize: "20px",
                              borderBottom: "2px solid white",
                              textAlign: "center",
                              backgroundColor: "#d5e5ff",
                              color: "black",
                            }}
                          >
                            eOps Users Status ({desginationName}) for {officeName} of{" "}
                            {getDateDifference(dateFrom, dateTo) > 0
                              ? formatDate(dateFrom) +
                                " to " +
                                formatDate(dateTo)
                              : formatDate(dateFrom)}
                          </th>
                        </tr>
                        <tr
                          style={{
                            position: "sticky",
                            top: "37px",
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          {connectionTypes.map((type, index) => (
                            <th
                              key={index}
                              style={{
                                width: `${100 / connectionTypes.length}%`,
                                textAlign: "left",
                                border: "5px solid white",
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "14px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              {type}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {viewBackdrop ? (
                          <tr>
                            <td
                              colSpan="15"
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                              >
                                <CircularProgress />
                              </Box>
                            </td>
                          </tr>
                        ) : tableData.length === 0 ? (
                          <tr>
                            <td
                              colSpan="15"
                              style={{
                                textAlign: "center",
                                padding: "10px",
                                fontWeight: "bold",
                                color: "red",
                              }}
                            >
                              No Data Found
                            </td>
                          </tr>
                        ) : (
                          <>
                            {tableData.map((item, index) => (
                              <tr
                                key={index}
                                style={{ borderBottom: "1px solid #ccc" }}
                              >
                                <td
                                  style={{
                                    backgroundColor: "white",
                                    textAlign: "left",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.officeCode}
                                </td>
                                <td
                                  style={{
                                    backgroundColor: "white",
                                    textAlign: "left",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.officeName}
                                </td>
                                <td
                                  style={{
                                    backgroundColor: "white",
                                    textAlign: "left",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.totalLoggedInWeb}
                                </td>
                                <td
                                  style={{
                                    backgroundColor: "white",
                                    textAlign: "left",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.totalLoggedInMobile}
                                </td>
                                <td
                                  style={{
                                    backgroundColor: "white",
                                    textAlign: "left",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.totalLoggedOut}
                                </td>
                                <td
                                  style={{
                                    backgroundColor: "white",
                                    textAlign: "left",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.totalUsers}
                                </td>
                              </tr>
                            ))}

                            {/* 🔹 Total Row */}
                            <tr
                              style={{
                                backgroundColor: "#fff5c0",
                                fontWeight: "bold",
                              }}
                            >
                              <td
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                Total
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                -
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {tableData.reduce(
                                  (sum, item) =>
                                    sum + (item.totalLoggedInWeb || 0),
                                  0
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {tableData.reduce(
                                  (sum, item) =>
                                    sum + (item.totalLoggedInMobile || 0),
                                  0
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {tableData.reduce(
                                  (sum, item) =>
                                    sum + (item.totalLoggedOut || 0),
                                  0
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {tableData.reduce(
                                  (sum, item) => sum + (item.totalUsers || 0),
                                  0
                                )}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Box>
      {/* {selectedRemarks && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableRestoreFocus
        >
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" sx={{ fontSize: "17px" }}>
              Remarks :
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{selectedRemarks}</Typography>
          </div>
        </Popover>
      )} */}
      {/* <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
    </>
  );
};

export default EopsUsersStatus;
